import type { SVGProps } from "react";
export interface FerryIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function FerryIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: FerryIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M17.691 19.883a1.77 1.77 0 0 1 1.95 0l.123.09.196.15c.46.333 1.129.695 1.868.746l.172.006.115.005a1.125 1.125 0 0 1 0 2.239l-.115.006-.314-.01c-1.306-.086-2.371-.686-3.02-1.152-.701.502-1.886 1.162-3.333 1.162s-2.634-.66-3.334-1.162c-.7.502-1.885 1.162-3.333 1.162s-2.633-.66-3.333-1.162c-.701.502-1.885 1.162-3.333 1.162a1.125 1.125 0 0 1 0-2.25c.923 0 1.755-.514 2.237-.901l.121-.091a1.77 1.77 0 0 1 1.95 0l.122.09.197.15c.495.358 1.233.752 2.04.752.922 0 1.755-.514 2.236-.901l.122-.091a1.77 1.77 0 0 1 1.95 0l.121.09.198.15c.494.358 1.232.751 2.039.752.923 0 1.755-.514 2.237-.901zM10.876 2a1.125 1.125 0 0 1 2.25 0v.875h4.004c.994 0 1.845.686 2.069 1.636l.036.193.88 6.25a1.125 1.125 0 0 1-2.229.314l-.864-6.143H6.979l-.864 6.143a1.125 1.125 0 0 1-2.23-.313l.88-6.25.036-.194a2.126 2.126 0 0 1 2.068-1.636h4.007z"
      />
      <path
        fill={color}
        d="M11.038 7.215a3.13 3.13 0 0 1 2.231.118l7.431 3.302.17.085a2.13 2.13 0 0 1 1.07 2.158l-.034.186-.958 4.067-.032.112a1.124 1.124 0 0 1-2.158-.626l.933-3.968-7.336-3.26a.88.88 0 0 0-.536-.056l-.175.055L4.31 12.65l.933 3.968.02.113a1.125 1.125 0 0 1-2.178.513l-.032-.111-.957-4.068a2.126 2.126 0 0 1 1.206-2.43l7.43-3.3z"
      />
    </svg>
  );
}
